import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

const useStyles = createMemoStyles(({ spacing, palette }: HeaderTheme) => ({
  infoMenu: {
    display: 'flex',

    '& > div > div > .wds-overlay': {
      top: spacing[7],
    },
  },
  descriptionBox: {
    whiteSpace: 'normal',
  },
  footnote: {
    padding: [spacing[1], spacing[5], spacing[6], spacing[5]],
    borderTop: [1, 'solid', palette.text.darkMuted],
    whiteSpace: 'normal',
  },
  helpIframe: {
    border: 'none',
  },
  notificationsContainer: {
    display: 'block',
    whiteSpace: 'normal',
  },
  notificationsList: {
    padding: 0,
    margin: 0,
  },
  notificationsBadgeContainer: {
    position: 'absolute',
    top: -1,
    left: 8,
  },
  notificationsBadgeContainerMobile: {
    '& > div': {
      border: 'none',
    },
  },
  notificationsBadge: {
    height: 24,
    minWidth: 24,
    padding: [2, 8],
    border: [3, 'solid', palette.text.dark],
    borderRadius: 12,
    color: palette.text.light,
    backgroundColor: palette.data.six,
    display: 'flex',
    justifyContent: 'space-around',
    lineHeight: 1,
    fontSize: 12,
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  notificationsEmpty: {
    '& > img': {
      width: '100%',
    },
  },
}));

export default useStyles;
